import { render, staticRenderFns } from "./NotesListNoteVisibility.vue?vue&type=template&id=6bea6498&"
import script from "./NotesListNoteVisibility.vue?vue&type=script&lang=js&"
export * from "./NotesListNoteVisibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports